export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg" {...props}>
            <defs>
                <filter colorInterpolationFilters="auto" id="hb5nnzzjca">
                    <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.600000 0 0 0 0 0.600000 0 0 0 0 0.600000 0 0 0 1.000000 0" />
                </filter>
            </defs>
            <g transform="translate(-290 -47.5)" filter="url(#hb5nnzzjca)" fill="none" fillRule="evenodd">
                <g stroke="#000" fill="#000" fillRule="nonzero">
                    <path d="M300 66a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-15a7 7 0 1 0 0 14 7 7 0 0 0 0-14z" strokeWidth=".4" />
                    <path
                        d="M301.95 54.46a2.13 2.13 0 0 1 .69 1.665 2.295 2.295 0 0 1-.43 1.42c-.315.323-.649.627-1 .91a2.04 2.04 0 0 0-.5.595 1.59 1.59 0 0 0-.185.78v.2h-1.22v-.2c-.013-.38.062-.759.22-1.105a6.375 6.375 0 0 1 1.33-1.445l.2-.22c.198-.24.31-.54.315-.85a1.34 1.34 0 0 0-.34-.955 1.325 1.325 0 0 0-1-.35 1.305 1.305 0 0 0-1.145.5 1.97 1.97 0 0 0-.315 1.2h-1.21a2.685 2.685 0 0 1 .745-2 2.705 2.705 0 0 1 2-.745 2.635 2.635 0 0 1 1.845.6zm-1.41 6.435a.765.765 0 0 1 .245.605.825.825 0 0 1-.245.605.915.915 0 0 1-.62.235.855.855 0 0 1-.845-.84.745.745 0 0 1 .255-.595.78.78 0 0 1 .595-.235c.227-.012.45.07.615.225z"
                        strokeWidth=".2"
                    />
                </g>
            </g>
        </svg>
    );
}
